import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaUserPlus, FaEnvelope, FaLock, FaUser, FaCheck } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

class AdminCreateAccount extends Component {
    constructor(props) {
        super(props)
        this.state = {
            processing: false,
            success: false,
            levels: [],
            level: null,
            firstname: null,
            lastname: null,
            email_address: null,
            password: null,
        }
    }

    create = async () => {
        if (!this.state.firstname || !this.state.lastname || !this.state.email_address || !this.state.password)
            NotificationManager.error('Missing information')
        else if (this.state.password.length < 8)
            NotificationManager.error('Password length must be at least 8 characters')
        else {
            try {
                this.setState({ processing: true })
                const data = await AdminService.createAdmin(this.state.password, this.state.email_address, this.state.firstname, this.state.lastname)
                NotificationManager.success(data.message)
                this.setState({ processing: false, success: true })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Create Admin Account"
                    breadcrumbs={[
                        { label: 'Accounts', path: '/admin/accounts' },
                        { label: 'Create' }
                    ]}
                >
                    {!this.state.success ? (
                        <div className="max-w-2xl mx-auto">
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                {/* Header */}
                                <div className="bg-gradient-to-r from-blue-500 to-indigo-600 px-6 py-4">
                                    <h3 className="text-xl font-bold text-white flex items-center gap-2">
                                        <FaUserPlus />
                                        New Administration Account
                                    </h3>
                                    <p className="text-sm text-white/90 mt-1">
                                        Create a new admin account with full access privileges
                                    </p>
                                </div>

                                {/* Form */}
                                <div className="p-6 space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                <FaUser className="inline mr-1 text-gray-500" />
                                                First Name *
                                            </label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter first name"
                                                onChange={(e) => this.setState({ firstname: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                <FaUser className="inline mr-1 text-gray-500" />
                                                Last Name *
                                            </label>
                                            <input 
                                                type="text" 
                                                placeholder="Enter last name"
                                                onChange={(e) => this.setState({ lastname: e.target.value })}
                                                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <FaEnvelope className="inline mr-1 text-gray-500" />
                                            Email Address *
                                        </label>
                                        <input 
                                            type="email" 
                                            placeholder="admin@example.com"
                                            onChange={(e) => this.setState({ email_address: e.target.value })}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            <FaLock className="inline mr-1 text-gray-500" />
                                            Password *
                                        </label>
                                        <input 
                                            type="password" 
                                            placeholder="Minimum 8 characters"
                                            onChange={(e) => this.setState({ password: e.target.value })}
                                            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                                        />
                                        <p className="text-xs text-gray-500 mt-1">Password must be at least 8 characters long</p>
                                    </div>

                                    <div className="pt-4 flex gap-3">
                                        <button
                                            onClick={() => window.location.href = '/admin/accounts'}
                                            className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all font-medium"
                                        >
                                            Cancel
                                        </button>
                                        {this.state.processing ? (
                                            <div className="flex-1 px-6 py-2.5 bg-gray-100 text-gray-500 rounded-lg flex items-center justify-center gap-2">
                                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                                Creating Account...
                                            </div>
                                        ) : (
                                            <button 
                                                onClick={this.create}
                                                className="flex-1 px-6 py-2.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center justify-center gap-2"
                                            >
                                                <FaUserPlus />
                                                Create Admin Account
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="max-w-2xl mx-auto">
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="p-12 text-center">
                                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 mb-4">
                                        <FaCheck className="text-3xl text-green-600" />
                                    </div>
                                    <h3 className="text-2xl font-bold text-gray-900 mb-2">Account Created Successfully!</h3>
                                    <p className="text-gray-600 mb-6">The new admin account has been created and is ready to use.</p>
                                    <button 
                                        onClick={() => window.location.href = '/admin/accounts'}
                                        className="px-6 py-2.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg"
                                    >
                                        Back to Accounts
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminCreateAccount)